import React, { useState, useRef, useEffect } from 'react';
import { format } from 'date-fns';
import { FiCalendar } from 'react-icons/fi';
import CalendarPopup from './calendar-popup';
import './style.scss';

const DateInput = ({ 
  value, 
  onChange, 
  placeholder = 'mm/dd/yyyy', 
  label = 'Pick Up Date',
  deliveryDate,
  pickupDate,
  name,
  register,
  error,
  className = ''
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleDateSelect = (date) => {
    const dateString = format(date, 'yyyy-MM-dd');
    if (onChange) {
      onChange(dateString);
    }
    setOpen(false);
  };

  const displayValue = value 
    ? format(new Date(value), 'MM/dd/yyyy') 
    : placeholder;

  return (
    <div className={`date-input-wrapper ${className}`} ref={ref}>
      {label && <label className="date-input-label">{label}</label>}
      <div 
        className={`date-input-box ${deliveryDate || pickupDate ? 'error' : ''} ${error ? 'error' : ''} ${value ? 'filled' : ''}`} 
        onClick={() => setOpen(!open)}
      >
        <span className={`date-input-value ${value ? 'filled' : ''}`}>
          {displayValue}
        </span>
        <FiCalendar className="calendar-icon" />
      </div>
      {error && (
        <span className="date-input-error">{error.message || error}</span>
      )}
      {open && (
        <div className="calendar-popup-container">
          <CalendarPopup
            selectedDate={value}
            onSelectDate={handleDateSelect}
          />
        </div>
      )}
    </div>
  );
};

export default DateInput;
